module.exports = __webpack_public_path__ + "media/m10.94b73473.mp4";